<template>
  <div>

    <!-- <vuestic-widget :headerText="$t(title)" v-if="isFlowAvailable"> -->
    <script2 src='https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js'> </script2>
    <script2 src='https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.1.3/js/bootstrap.min.js'> </script2>
    <script2 src='https://screenshare.fractel.net/js/before.js'> </script2>
    <script2 src='https://screenshare.fractel.net/socket.io/socket.io.js'> </script2>
    <script2 src='https://screenshare.fractel.net/js/getScreenId.js'> </script2>
    <script2 src='https://screenshare.fractel.net/js/BandwidthHandler.js'></script2>
    <script2 src='https://screenshare.fractel.net/js/screen.js'> </script2>

    <div class="row">
      <div class="col">
        <div class="row" id="screenview">
          <div class="col-md-12">
            <div class="col-md-4" id="user-name">
            </div>
            <div class="col-md-3 offset-4" id="media_source">
              <select class="form-control" style="margin-top: 3em;" id="media_source_select" v-if="firefox">
                <option value="screen">Screen</option>
                <option value="window">Window</option>
                <option value="application">Application</option>
              </select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="col-md-6 offset-3" style="margin-top: 3em;" id="prereq" v-if="show">
              <h4 id="reuirement-alert"></h4>
            </div>
            <div class="col-md-4 offset-4" style="margin-top: 3em;" id="share-screen" v-else>
              <button class="btn btn-primary">Share My Screen</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 col-md-offset-1" style="padding-bottom:5px;">
            <h4 style="font-weight:500; display:none;" id="code-h4">Please tell viewers to enter this code <span id="code" class="skrum-color"></span> at <a href="/#/screenshare" target="_blank">https://dashboard.fractel.net/#/screenshare</a>
            <br />Share this Info: <a id="shareScreen" href="mailto:?subject=View My Screen&body=Click on following link to view my screen: https://dashboard.fractel.net/#/screenshare" title="Share by Email"><i class="material-icons">email</i></a>
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-md-offset-4">
            <!-- list of all available broadcasting rooms -->
            <table style="width: 100%;" id="rooms-list"></table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 offset-3" style="padding-bottom:5%;">
            <!-- local/remote videos container -->
            <div id="videos-container"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-7 offset-5" style="margin-top: 1em;">
            <h1>OR</h1>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6 form-group">
                <div class="col-md-6 offset-6 input-group">
                  <input type="text" name="view_id" id="view_id" placeholder="Screen Share ID" style="color:#000000;" />
                  <i class="bar"></i>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-md-6">
                  <input type="button" class="btn btn-primary btn-raised btn-block" id="IdButton" value="View Screen" />
                </div>
                <div class="col-md-8">
                  <p id="alert" style="color:red;"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal for Browser support alert -->
    <!-- <div class="modal fade" role="dialog" id="alertModal" v-if="show">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <a class="close" data-dismiss="modal">&times;</a>
            <h3>Requirements</h3>
          </div>
          <div class="modal-body">
            <h4 id="reuirement-alert"></h4>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-info btn-raised" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div> -->
    <script2 src='https://screenshare.fractel.net/js/after.js'> </script2>
    <script2 src='https://screenshare.fractel.net/js/check.js'> </script2>
  </div>
</template>
<script>
  export default {
    name: 'collaboration-tab',
    data: function () {
      return {
        screenshare_url: process.env.SCREENSHARE_URL,
        screenshare_extension: process.env.SCREENSHARE_EXTENSION,
        show: true,
        firefox: false
      }
    },
    mounted: function () {
      this.onLoad()
    },
    methods: {
      onLoad () {
        var self = this
        var extensionId = self.screenshare_extension
        var alert = document.getElementById('reuirement-alert')
        var isFirefox = typeof InstallTrigger !== 'undefined'
        var isChrome = !!navigator.webkitGetUserMedia

        if (isChrome) {
          var image = document.createElement('img')
          image.src = 'chrome-extension://' + extensionId + '/icon.png'
          image.onload = function () {
            console.log('installed')
            self.show = false
          }
          image.onerror = function () {
            alert.innerHTML = 'Please download FracTEL Screen Share Chrome Extension. Click <a href="https://chrome.google.com/webstore/detail/screen-capturing/' + extensionId + '" target="_blank">here</a> to download.'
            // self.show = true
          }
        } else if (isFirefox) {
          self.firefox = true
          navigator.sayswho = (function () {
            var ua = navigator.userAgent
            var tem
            var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
            if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
            return M[1]
          })()
          if (parseInt(navigator.sayswho) < 52) {
            alert.innerHTML = 'Please update your firefox. Screen Sharing required firefox version 52.0 or newer.'
            // self.show = true
          }
        } else {
          alert.innerHTML = 'Screen sharing is not supported in this browser. Please use Google Chrome Desktop or Firefox Desktop.'
          // self.show = true
        }
      }
    }
  }
</script>
<style lang="scss">
  @import "../../../sass/variables";

  th.active {
  color: $fractel-teal;
  }

  th.active .arrow {
  opacity: 1;
  }

  .arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0;
  }

  .arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
  }

  .arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
  }

  .search-input {
    border: 1px solid black;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/collaboration-tab/Collaboration.vue